const states = {
    alabama: 'AL',
    alaska: 'AK',
    arizona: 'AZ',
    arkansas: 'AR',
    california: 'CA',
    colorado: 'CO',
    connecticut: 'CT',
    delaware: 'DE',
    florida: 'FL',
    georgia: 'GA',
    hawaii: 'HI',
    idaho: 'ID',
    illinois: 'IL',
    indiana: 'IN',
    iowa: 'IA',
    kansas: 'KS',
    kentucky: 'KY',
    louisiana: 'LA',
    maine: 'ME',
    maryland: 'MD',
    massachusetts: 'MA',
    michigan: 'MI',
    minnesota: 'MN',
    mississippi: 'MS',
    missouri: 'MO',
    montana: 'MT',
    nebraska: 'NE',
    nevada: 'NV',
    'new Hampshire': 'NH',
    'new Jersey': 'NJ',
    'new Mexico': 'NM',
    'new York': 'NY',
    'north Carolina': 'NC',
    'north Dakota': 'ND',
    ohio: 'OH',
    oklahoma: 'OK',
    oregon: 'OR',
    pennsylvania: 'PA',
    'rhode Island': 'RI',
    'south Carolina': 'SC',
    'south Dakota': 'SD',
    tennessee: 'TN',
    texas: 'TX',
    utah: 'UT',
    vermont: 'VT',
    virginia: 'VA',
    washington: 'WA',
    'west Virginia': 'WV',
    wisconsin: 'WI',
    wyoming: 'WY'
}

class AddressUtils {
    static getStateAbbrev(fullName) {
        if (fullName) {
            const abbrev = states[fullName.toLowerCase()];
            if (abbrev) {
                return abbrev;
            }
        }

        return fullName;
    }

    static combineAddress(company) {
        const addr1 = company.address1;
        const addr2 = company.address2;
        const city = company.city;
        const state = AddressUtils.getStateAbbrev(company.state);
        const zip = company.zip;

        let address = addr1;
        address += (addr2 && ' ') + addr2;
        address += (city && ' ') + city;
        address += (state && ', ') + state;
        address += (zip && ' ') + zip;

        return address;
    }
}

export { AddressUtils };
